import { connect } from 'react-redux';
import { entitySelectors } from '@store/entity/selectors';
import { Categories } from './Categories';

const mapStateToProps = (state) => ({
  categories: entitySelectors.getAllCategories(state),
});

export const CategoriesContainer: any = connect(mapStateToProps)(Categories);
